<template>
    <div class="flex flex-col items-center justify-center rounded-2xl transition-all duration-300 transform shadow-sm h-32 md:h-40 cursor-pointer"
        :class="containerClass" @click="$emit('click')">
        <span class="text-2xl tracking-tighter">{{ name }}</span>
        <span v-if="type === 'tool'" class="text-[10px] mt-2 opacity-60 border border-current px-1 rounded">TOOL</span>
    </div>
</template>

<script setup>
/* global defineProps, defineEmits */
defineProps(['name', 'containerClass', 'type']);
defineEmits(['click']);
</script>